"use client";
import * as React from "react";
import { DataTable, type Column } from "../DataTable";
import { PageHeader, StatCard, Card2 } from "../ModuleHelpers";
import { useERP, formatNum } from "@/lib/erp/store";
import { UserCog } from "lucide-react";

export function SFAModule() {
  const erp = useERP();
  const visits = erp.employees.filter(e => e.department === "Sales").flatMap((emp, i) =>
    erp.customers.slice(i, i + 2).map((c, j) => ({
      id: `${emp.id}-${c.id}-${j}`, emp: emp.name, customer: c.name, zone: c.zone,
      date: "2026-10-12", status: j === 0 ? "Completed" : "Planned", outcome: j === 0 ? "Order Booked" : "—",
    }))
  );
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Field Sales (SFA)" desc="Field visits, beat plans and order capture from the field." icon={UserCog} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Active Reps" value={formatNum(erp.employees.filter(e => e.department === "Sales").length)} />
        <StatCard label="Visits Today" value={formatNum(visits.filter(v => v.status === "Completed").length)} />
        <StatCard label="Conversion" value="68%" tone="text-primary" />
        <StatCard label="Avg Visit Time" value="32 min" />
      </div>
      <Card2 title="Field Visits">
        <DataTable
          columns={[
            { key: "emp", header: "Salesman", sortable: true },
            { key: "customer", header: "Customer" },
            { key: "zone", header: "Zone" },
            { key: "date", header: "Date" },
            { key: "outcome", header: "Outcome" },
            { key: "status", header: "Status", render: r => <span className={`inline-flex rounded-md px-2 py-0.5 text-xs ${r.status === "Completed" ? "bg-primary text-primary-foreground" : "bg-secondary"}`}>{r.status}</span> },
          ] as Column<typeof visits[number]>[]}
          data={visits}
          rowKey={r => r.id}
          searchKeys={["emp", "customer", "zone"]}
        />
      </Card2>
    </div>
  );
}
